module.exports = __webpack_public_path__ + "assets/img/is-favorite.9128951c.svg";